import { render } from "./SubRequestDetails.vue?vue&type=template&id=7f936c5c&scoped=true"
import script from "./SubRequestDetails.vue?vue&type=script&lang=js"
export * from "./SubRequestDetails.vue?vue&type=script&lang=js"

import "./SubRequestDetails.vue?vue&type=style&index=0&id=7f936c5c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f936c5c"]])

export default __exports__